module.exports = __webpack_public_path__ + "img/ZWF_Dominik_Monika.089cf226.jpg";